export default "__VITE_ASSET__BV6l4H2g__"